import { render } from "./TableDropdown.vue?vue&type=template&id=0aa868ca"
import script from "./TableDropdown.vue?vue&type=script&lang=js"
export * from "./TableDropdown.vue?vue&type=script&lang=js"

import exportComponent from "D:\\fclinique\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__